import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';

import { CurrencyFormat } from '@lt/components';
import type { CurrencyType } from '@lt/components/utils/currency';
import { pluralize } from '@lt/components/utils/userflow';
import BubbleFilter from 'src/components/Bubbles/BubbleFilter';

interface IFilterLable {
  className?: string;
  price?: string | number;
  currencyCode?: CurrencyType;
  name: string;
  description?: string;
  count?: number;
  disabled?: boolean;
  selected?: boolean;
  isMobile?: boolean;
  emptyMessage?: string;
}

const FilterLabel: React.FC<IFilterLable> = ({
  count = 0,
  price,
  currencyCode,
  name,
  emptyMessage = 'нет отелей',
  description,
  isMobile = false,
  selected = false,
  disabled = false,
  className,
}) => {
  const hasOffersCount = count > 0;
  return (
    <StyledFilterLabel
      className={className}
      disabled={disabled}
      selected={selected}
      isMobile={isMobile}
    >
      <StyledItemNameContainer $isMobile={isMobile}>
        {name}
        {description && !isMobile ? (
          <BubbleFilter text={description} placement="right" />
        ) : null}
      </StyledItemNameContainer>
      <StyledItemInfo>
        {!disabled && hasOffersCount && (
          <>
            {`${count} ${pluralize(count, ['отель', 'отеля', 'отелей'])}`}
            <CurrencyFormat
              value={price}
              currencyCode={currencyCode}
              prefix=" от "
            />
          </>
        )}
        {disabled ? emptyMessage : null}
      </StyledItemInfo>
    </StyledFilterLabel>
  );
};

FilterLabel.propTypes = {
  className: PropTypes.string,
};

FilterLabel.defaultProps = {
  className: '',
};

const StyledItemNameContainer = styled.div<{ $isMobile?: boolean }>`
  ${({ $isMobile }) =>
    !$isMobile &&
    `
    white-space: pre-wrap;
  `}
  overflow: hidden;
  text-overflow: ellipsis;
`;

const StyledItemInfo = styled.div`
  white-space: nowrap;
`;
export const StyledFilterLabel = styled.div<{
  isMobile: boolean;
  disabled: boolean;
  selected: boolean;
}>`
  overflow: hidden;
  width: 100%;
  font-size: ${({ isMobile }) => (isMobile ? 17 : 14)}px;

  ${({ theme, disabled, selected }) =>
    !disabled &&
    css`
      color: ${selected ? theme.colors.black : theme.colors.blackLight};

      &:hover {
        color: ${theme.colors.black};
      }
    `}

  ${({ theme, disabled }) =>
    disabled &&
    css`
      color: ${theme.colors.greyLight};
    `}

  ${StyledItemInfo} {
    font-size: ${({ isMobile }) => (isMobile ? 13 : 12)}px;
    color: ${({ selected, disabled, theme }) =>
      selected || disabled ? 'inherit' : theme.colors.greyLight};
  }
`;

export default React.memo(FilterLabel);
